import { render } from "./CustomerSegmentEditSetting.vue?vue&type=template&id=caa4d2ec&scoped=true"
import script from "./CustomerSegmentEditSetting.vue?vue&type=script&lang=js"
export * from "./CustomerSegmentEditSetting.vue?vue&type=script&lang=js"

import "./CustomerSegmentEditSetting.vue?vue&type=style&index=0&id=caa4d2ec&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa4d2ec"]])

export default __exports__